import React from 'react';
import RepayLoanComponent from '../components/repay-loan'; // Sirf ek import

const RepayLoan = () => {
  return (
    <div className="repay-loan-wrapper">
      {/* Ab yahan sirf ek bar search bar dikhega */}
      <RepayLoanComponent />
    </div>
  );
};

export default RepayLoan;